import { style } from '@do/walrus';
import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { Err, ErrorBanner } from '../Common';
import newBrandDesignVars from './overwrite-vars.scss';

const NewErrorBannerWrapper = styled.div`
  div:first-child {
    border: ${style.vars.borderWidth.thin} solid
      ${newBrandDesignVars.red_darkest};
    background-color: ${newBrandDesignVars.red_lightest};
    box-sizing: border-box;
    border-radius: ${newBrandDesignVars.border_radius_xlarge};
    padding: ${style.vars.whitespace.regular};

    & svg {
      margin-top: 0 !important;
      margin-right: ${style.vars.whitespace.small} !important;
      width: 32px;
      height: 32px;
    }

    & small {
      color: ${newBrandDesignVars.grey2};
      font-size: ${newBrandDesignVars.font_size_medium};
      font-weight: normal;
    }

    .do-u-textSmall {
      font-size: 1rem !important;
      color: ${newBrandDesignVars.dark};
    }
  }
`;

const NewErrorBanner = (props: Err): ReactElement => {
  return (
    <NewErrorBannerWrapper>
      <ErrorBanner {...props} />
    </NewErrorBannerWrapper>
  );
};

export default NewErrorBanner;
